/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React, { useContext, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom'
import SideNavBar from './Sidebar';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userService } from '../../services/user.services';
import GlobalContext from '../Context/GloablContext';

export default function Layout() {
    const { setToastmessage, UpdateCall, setUpdateCall,setToastErrorMessage,isSideBar,setToastWarnmessage,restrictKey } = useContext(GlobalContext)
    const navigate = useNavigate()
    // const auth = useSelector(state => state.auth);
    // const {userType} = auth
    // const SideBar = useMemo(() => <SideBar role={userType} />, []);
    // const handlecheckStatus = async () => {
    //     console.log('check status called')
    //     if(localStorage.getItem('IdToken')  !== null){
    //         const response = await userService.checkStatus()
    //         if(response.error === false) {
    //             if(response.data.account_status === 'inactive'){
    //                 localStorage.clear()
    //                 setToastErrorMessage(`You've been logged out, your account is deactivated or session timed out. Please log in again.`)
    //                 navigate('/')
    //             }
    //         } else {
    //         // setToastErrorMessage('Something went wrong!')
    //         }
    //     }
    // }
    

    // useEffect(() => {
    //     handlecheckStatus()
    // }, [])
    



    return (
        <>
            <div className="flex h-screen overflow-x-hidden">
                <SideNavBar role={'Profile'}/>
                <Outlet />
            </div>
           
        </>
        
    )
}
